import { useEffect, useState } from "react";
import styles from "./Popup.module.css";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select } from "@mui/material";
import { authData } from "../../components/GetAuth";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";

export default function ReassignDeliveryDriverPopup({ setLoading, modalClose, itemIds, onSubmit }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [driverList, setDriverList] = useState([]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/delivery/driver-dd-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const onSubmitLocal = (data) => {
    setLoading(true);

    let postData = { driver_id: data?.driver_id, item_ids: itemIds };

    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/reassign-driver-items", postData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        modalClose(false);
        onSubmit(response.data.message);
      }
      // else: surface response.data.message via a snackbar if you wire one through
    }).catch((error) => {
      setLoading(false);
    });
  }

  const unAssigned = () => {
    setLoading(true);

    let postData = { item_ids: itemIds };

    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/unassign-driver-items", postData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        modalClose(false);
        onSubmit(response.data.message);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    <DialogTitle id="customized-dialog-title" className={`${styles.PopupTitleBar}`}>
      Assign Booking Details To Driver
      <IconButton aria-label="close" onClick={(e) => modalClose(false)} className={`${styles.PopupCloseBU}`}><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormGroupFull}`}>
          <div className={`FormHalfGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select Driver*</InputLabel>
              <Controller
                control={control}
                {...register("driver_id", { required: "Please select driver" })}
                render={({ field }) => (<Select {...field} label="Select Driver*">
                  {driverList?.map((i) => {
                    return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
                  })}
                </Select>)}
              />
            </FormControl>
            {errors.driver_id && (<span className={`ErrorM`}>{errors?.driver_id?.message}</span>)}
          </div>
        </div>

        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => unAssigned()}>Un-Assign</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Re-Assign</Button>
        </div>
      </form>
    </DialogContent>
  </>);
}